import { useState } from 'react'
import { useApi } from './useApi'

/**
 * Hook for managing report executions
 */
export function useExecutions() {
  const api = useApi()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  async function getReportExecutions(reportId) {
    setLoading(true)
    setError(null)
    try {
      const data = await api.get(`/reports/${reportId}/executions`)
      return data
    } catch (err) {
      setError(err.message)
      throw err
    } finally {
      setLoading(false)
    }
  }

  async function getExecution(executionId) {
    setLoading(true)
    setError(null)
    try {
      // URL-encode the execution ID to handle special characters like #
      const encodedId = encodeURIComponent(executionId)
      const execution = await api.get(`/executions/${encodedId}`)
      return execution
    } catch (err) {
      setError(err.message)
      throw err
    } finally {
      setLoading(false)
    }
  }

  async function retryExecution(executionId) {
    setLoading(true)
    setError(null)
    try {
      const encodedId = encodeURIComponent(executionId)
      const result = await api.post(`/executions/${encodedId}/retry`, {})
      return result
    } catch (err) {
      setError(err.message)
      throw err
    } finally {
      setLoading(false)
    }
  }

  async function resendEmail(executionId) {
    setLoading(true)
    setError(null)
    try {
      const encodedId = encodeURIComponent(executionId)
      const result = await api.post(`/executions/${encodedId}/resend`, {})
      return result
    } catch (err) {
      setError(err.message)
      throw err
    } finally {
      setLoading(false)
    }
  }

  return {
    loading,
    error,
    getReportExecutions,
    getExecution,
    retryExecution,
    resendEmail
  }
}
